import { AbstractControl } from '@angular/forms';

export function whiteSpaceValidator(control: AbstractControl) {
  if (control.value === '' || control.value?.trim().length) {
    return null;
  }
  return { whitespace: true };
}
